import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import EmptyList from 'primary/EmptyList';

import Columns from './Columns';
import Content from './Content';
import CurveModal from './CurveModal';

import { Else, If, Then, When } from 'react-if';

import './DataTab.scss';

const emptyArray = []
const DataTab = () => {
  const selectedCurves = useSelector(state => state.curvesState.creatorState.selectedCurves) || emptyArray,
        [isInfoModalOpen, setIsInfoModalOpen] = useState(false),
        [selectedSymbolIndex, setSelectedSymbolIndex] = useState(),
        swapIsInfoModalOpen = useCallback(() => setIsInfoModalOpen(isOpen => !isOpen), [])

  return (
    <div className="ng-office-app__authed__content__basket__body__data ng-office-app__authed__content__basket__body__data--curve">
      <Columns/>
      <div className="ng-office-app__authed__content__basket__body__data__basket">
        <If condition={selectedCurves.length === 0}>
          <Then>
            {() => (
              <EmptyList
                  subtitle="Add curves to the basket in the creator."
                  title="Basket is empty."
              />
            )}
          </Then>
          <Else>
            {() => (
              <Content
                  setSelectedSymbolIndex={setSelectedSymbolIndex}
                  swapIsInfoModalOpen={swapIsInfoModalOpen}
              />
            )}
          </Else>
        </If>
      </div>
      <When condition={isInfoModalOpen}>
        {() => (
          <CurveModal
              index={selectedSymbolIndex}
              onClose={swapIsInfoModalOpen}
          />
        )}
      </When>
    </div>
  )
}

export default DataTab;